import React from 'react';
import { Alert } from '@mui/material';
import GridContent from './GridContent';

type GraphqlErrorAlertProps = {
  /**
   * If true, standard padding is not added
   */
  compact?: boolean;
  /**
   * The error message to show
   */
  errorMessage: string;
};

/**
 * A MUI `Box` component with (optional) standard padding for
 * content in a `Grid` layout.
 * Smaller padding at mobile sizes (below xs).
 */
const GraphqlErrorAlert: React.FC<GraphqlErrorAlertProps> = ({ compact, errorMessage }: GraphqlErrorAlertProps) => {
  const alert = <Alert severity="error">{errorMessage}.</Alert>;
  if (compact) return alert;
  return (
    <GridContent>
      {alert}
    </GridContent>
  );
};

export default GraphqlErrorAlert;